const listeners = new Set();

let cachedStatus = {
  offline: false,
  message: "",
  lastErrorAt: null,
};

const notify = (nextStatus) => {
  cachedStatus = nextStatus;
  listeners.forEach((listener) => {
    try {
      listener(cachedStatus);
    } catch (error) {
      console.error("NetworkStatus listener error", error);
    }
  });
};

export const subscribeToNetworkStatus = (listener) => {
  listeners.add(listener);
  listener(cachedStatus);

  return () => {
    listeners.delete(listener);
  };
};

export const notifyNetworkError = (message = "") => {
  if (cachedStatus.offline && cachedStatus.message === message) {
    return;
  }

  notify({
    offline: true,
    message,
    lastErrorAt: new Date().toISOString(),
  });
};

export const notifyNetworkRecovered = () => {
  if (!cachedStatus.offline) {
    return;
  }

  notify({
    offline: false,
    message: "",
    lastErrorAt: null,
  });
};
